document.addEventListener('DOMContentLoaded', function () {
  const swiper_collection = new Swiper('.logo-list', {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {                       
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
     640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1524: {
        slidesPerView: 4,
        spaceBetween: 30,
      },     
    }
  });
});